import { useApp } from '../AppContext';
import './ProfileTab.css';

export default function ProfileTab() {
  const { user, logout, notifyCircle, setNotifyCircle, showToast } = useApp();

  function openInvite() {
    document.getElementById('invite-modal')?.classList.add('visible');
  }

  function toggleNotify() {
    const next = !notifyCircle;
    setNotifyCircle(next);
    showToast(next ? 'Circle will see when you forgive' : 'Your forgiveness stays private');
  }

  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Auto';

  return (
    <div className="profile-tab">
      <div className="profile-card">
        <div className="avatar profile-avatar">{user?.initials || '?'}</div>
        <div className="profile-name">{user?.name || 'Friend'}</div>
        <div className="profile-email">{user?.email || ''}</div>
        <div className="profile-member">Member of Mercy ☽</div>
      </div>

      <div className="settings-list">
        <div className="settings-item" onClick={openInvite}>
          <span className="settings-label">Invite link</span>
          <span className="settings-arrow">›</span>
        </div>
        <div className="settings-item" onClick={toggleNotify}>
          <span className="settings-label">Notify my circle when I forgive</span>
          <span className="settings-value" style={{ color: notifyCircle ? 'var(--gold)' : 'var(--text-muted)' }}>
            {notifyCircle ? 'On' : 'Off'}
          </span>
        </div>
        <div className="settings-item">
          <span className="settings-label">Midnight reset timezone</span>
          <span className="settings-value">{tz}</span>
        </div>
      </div>

      <button className="signout-btn" onClick={logout}>Sign out</button>
    </div>
  );
}
